import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type {
    TaskHistoryApi,
    TaskHistoryRequest,
    TaskHistoryResponse,
    TaskRoutingHistoryResponse,
} from '../task-history-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';

@injectable()
export class TaskHistoryApiImpl extends GuestAwareHttpService implements TaskHistoryApi {
    async getTaskHistory(request: TaskHistoryRequest): Promise<TaskHistoryResponse> {
        const res = await this.getWithGuestSupport<TaskHistoryResponse>(
            'task/history',
            {
                task_id: request.task_id,
            }
        );
        return res;
    }

    /** 中转页只读取 taskId 和 stepType，不改变原有完整历史接口的响应类型。 */
    async getTaskRoutingHistory(
        request: TaskHistoryRequest
    ): Promise<TaskRoutingHistoryResponse> {
        return this.getWithGuestSupport<TaskRoutingHistoryResponse>(
            'task/history',
            {
                task_id: request.task_id,
            }
        );
    }
}
